<div class="card">
    <div class="card mb-2">
        <div class="card-header">
            Company Employee Details
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-3">
                    <label class="small-light-label">Employee Name</label><br />
                    <label>{{CompanyDetails[0].EmpName}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Employee Code</label><br />
                    <label>{{CompanyDetails[0].EmpCode}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Employee Type</label><br />
                    <label>{{CompanyDetails[0].EmpType}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Branch</label><br />
                    <label>{{CompanyDetails[0].BranchName}}</label>
                </div>
            </div>
        </div>
    </div>
    <div class="card mb-2">
        <div class="card-header">
            Company Employee Details
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-3">
                    <label class="small-light-label">Client</label><br />
                    <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                        (change)="onSelectChange('Client'); ComboLoad('Site')">
                        <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                            {{ segment.ClientGroupName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Site</label><br />
                    <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="SiteId" (change)="onSelectChange('Site'); ComboLoad('Designation')">
                        <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                            {{ segment.SiteName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Salary Type</label><br />
                    <ng-select name="salarytype" [items]="SalaryLoad" bindLabel="CategoryName"
                        bindValue="CategoryMasterID" [(ngModel)]="SalaryID" (change)="onSelectChange('Salary')">
                        <ng-option *ngFor="let segment of SalaryLoad" [value]="segment.CategoryMasterID">
                            {{ segment.CategoryName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Joining Date</label><br />
                    <div class="input-group">
                        <input class="form-control" name="joiningdate" placeholder="Ex. YYYY/MM/DD" ngbDatepicker
                            #d="ngbDatepicker" [(ngModel)]="JoningDate" [minDate]="{ year: 1930, month: 1, day: 1 }"
                            [maxDate]="{ year: 2124, month: 12, day: 31 }" required />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"
                            type="button"></button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="small-light-label">Probation Date</label><br />
                    <div class="input-group">
                        <input class="form-control" name="probationdate" placeholder="Ex. YYYY/MM/DD" ngbDatepicker
                            #d1="ngbDatepicker" [(ngModel)]="ProbationDate" [minDate]="{ year: 1930, month: 1, day: 1 }"
                            [maxDate]="{ year: 2124, month: 12, day: 31 }" required />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()" type="button"
                            type="button"></button>
                    </div>

                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Designation</label><br />
                    <ng-select name="designation" [items]="DesignationLoad" bindLabel="DesignationName"
                        [(ngModel)]="DesignationId" (change)=" onSelectChange('Designation'); ComboLoad('Duty')"
                        bindValue="DesignationMasterID">
                        <ng-option *ngFor="let segment of DesignationLoad" [value]="segment.DesignationMasterID">
                            {{ segment.DesignationName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Duty</label><br />
                    <ng-select name="dutyname" [items]="DutyLoad" [(ngModel)]="DutyId" (change)="onSelectChange('Duty')"
                        bindLabel="DutyName" bindValue="DutyMasterID">
                        <ng-option *ngFor="let segment of DutyLoad" [value]="segment.DutyMasterID">
                            {{ segment.DutyName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Department</label><br />
                    <ng-select name="Department" [items]="DepartmentLoad" [(ngModel)]="DepartmentID"
                        (change)="onSelectChange('Department')" bindLabel="DepartmentName"
                        bindValue="DepartmentMasterID">
                        <ng-option *ngFor="let segment of DepartmentLoad" [value]="segment.DepartmentMasterID">
                            {{ segment.DepartmentName }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3"><br>
                    <label class="small-light-label" style="margin-left: 3%;">
                        Metro City :
                        <input type="checkbox" name="MetroCity" [(ngModel)]="MetroCity" ngbCheckbox />
                    </label>
                </div>
                <div class="col-md-3"><br>
                    <label class="small-light-label" style="margin-left: 3%;">
                        Auto TDS Flag :
                        <input type="checkbox" name="autotds" [(ngModel)]="AutoTDSFlag" ngbCheckbox />
                    </label>
                </div>
                <div class="col-md-3" *ngIf="EmpType === 'Front'">
                    <label class="small-light-label">Contract Start Date </label><br />
                    <div class="input-group">
                        <input class="form-control" name="contractstartdate" placeholder="Ex. YYYY/MM/DD" ngbDatepicker
                            #d2="ngbDatepicker" [(ngModel)]="ContractStartDate"
                            [minDate]="{ year: 1930, month: 1, day: 1 }" [maxDate]="{ year: 2124, month: 12, day: 31 }"
                            required />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d2.toggle()" type="button"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-3" *ngIf="EmpType === 'Front'">
                    <label class="small-light-label">Contract End Date</label><br />
                    <div class="input-group">
                        <input class="form-control" name="contractenddate" placeholder="Ex. YYYY/MM/DD" ngbDatepicker
                            #d3="ngbDatepicker" [(ngModel)]="ContractEndDate"
                            [minDate]="{ year: 1930, month: 1, day: 1 }" [maxDate]="{ year: 2124, month: 12, day: 31 }"
                            required />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d3.toggle()" type="button"
                            type="button"></button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="small-light-label">Reporting Manager 1</label><br />
                    <ng-select name="reportmanager1" [items]="UserLoad" [(ngModel)]="Report1ID"
                        (change)="onSelectChange('reporting1')" bindLabel="UserName" bindValue="UserMasterId">
                        <ng-option *ngFor="let segment of UserLoad" [value]="segment.UserMasterId">
                            {{ segment.UserName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Reporting Manager 2</label><br />
                    <ng-select name="reportmanager2" [items]="UserLoad" [(ngModel)]="Report2ID"
                        (change)="onSelectChange('reporting2')" bindLabel="UserName" bindValue="UserMasterId">
                        <ng-option *ngFor="let segment of UserLoad" [value]="segment.UserMasterId">
                            {{ segment.UserName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Shift</label><br />
                    <ng-select name="Shift" [items]="Shift" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                        [(ngModel)]="ShiftID" (change)="onSelectChange('Shift')">
                        <ng-option *ngFor="let segment of Shift" [value]="segment.ShiftMasterID">
                            {{ segment.ShiftTitle }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label">Present Working Status</label><br />
                    <ng-select name="presentworkingstatus" [items]="WorkingStatusLoad" bindLabel="WorkStatusName"
                        bindValue="WorkStatusMasterID" [(ngModel)]="PresentStatusId"
                        (change)="onSelectChange('workstatus')">
                        <ng-option *ngFor="let segment of WorkingStatusLoad" [value]="segment.WorkStatusMasterID">
                            {{ segment.WorkStatusName }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="small-light-label">Status Date</label><br />
                    <div class="input-group">
                        <input class="form-control" name="statusdate" placeholder="Ex. YYYY/MM/DD" ngbDatepicker
                            #d5="ngbDatepicker" [(ngModel)]="StatusMasterDate"
                            [minDate]="{ year: 1930, month: 1, day: 1 }" [maxDate]="{ year: 2124, month: 12, day: 31 }"
                            required />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d5.toggle()" type="button"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-3" *ngIf="EmpType === 'Back'">
                    <label class="small-light-label">Office Email</label><br />
                    <input name="officeEmail" type="text" [(ngModel)]="OfficeEmail" class="form-control" />
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
                    class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>

            <button class="btn btn-sm btn-primary" name="add" (click)="Save()">
                <i class="bi bi-save" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Save':'Loading...'}}
            </button>
        </div>
    </div>
</div>